export const CONFIRM_EMAIL_FIELD_NAME = 'confirmEmail';
export const EMAIL_FIELD_NAME = 'email';

export const ALTERNATE_ID_FIELD_NAME = 'alternateId';
export const NCCER_CARD_NUMBER_FIELD_NAME = 'cardNumber';
